/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */

// Imports

import {useEffect} from "react"
import {useVideoSuspenders} from "trux/dist/organisms/VideoPlayer"

export const useSuspendedVideo = (videoContainerRef) => {
    
    const {suspend, resume} = useVideoSuspenders(videoContainerRef)

    useEffect(() => {
        suspend() 
        return () => {
            resume()
        }
    }, [videoContainerRef?.current])
}